import Polyglot from "node-polyglot"
import englishMessages from "./locales/en.json"
import germanMessages from "./locales/de.json"
import frenchMessages from "./locales/fr.json"
import locale2 from "locale2"
import app from "./app.controller"
import store from "store"
import queryString from "querystring"

let polyglot
let translate

let availableTranslations = {
  en: englishMessages,
  fr: frenchMessages,
  de: germanMessages,
}

const parsed = queryString.parse( document.location.search.substr( 1 ) )
app._currentLanguage = parsed.lang || store.get( "lang" ) || "en"

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject( item ) {
  return (item && typeof item === 'object' && !Array.isArray( item ));
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep( target, ...sources ) {
  if ( !sources.length ) return target;
  const source = sources.shift();
  
  if ( isObject( target ) && isObject( source ) ) {
    for ( const key in source ) {
      if ( isObject( source[ key ] ) ) {
        if ( !target[ key ] ) Object.assign( target, { [ key ]: {} } );
        mergeDeep( target[ key ], source[ key ] );
      } else {
        Object.assign( target, { [ key ]: source[ key ] } );
      }
    }
  }
  
  return mergeDeep( target, ...sources );
}


const handleLanguageChange = ( locale ) => {
  if ( locale.indexOf( "de" ) !== -1 ) app._currentLanguage = "de"
  if ( locale.indexOf( "en" ) !== -1 ) app._currentLanguage = "en"
  if ( locale.indexOf( "fr" ) !== -1 ) app._currentLanguage = "fr"
  let phrases = availableTranslations[ app._currentLanguage ] || germanMessages
  
  // EN FALLBACK
  if ( app._currentLanguage === "fr" ) {
    mergeDeep( phrases, availableTranslations[ "en" ] )
  }
  
  let translation = {
    locale,
    phrases
  }
  
  polyglot = new Polyglot( translation )
  translate = polyglot.t.bind( polyglot )
  store.set( "lang", app._currentLanguage )
}

function getPhrases( locale ) {

}

app.language.changed.add( handleLanguageChange )
handleLanguageChange( parsed.lang || store.get( "lang" ) || locale2 )

window.translate = translate // Tired of importing it. It's global now.
export { translate }



// WEBPACK FOOTER //
// ./src/translate.js